import React from "react"
export default function Suspence() {
  return (
    <>
    {/* yumdel_logo */}
    {/* logo.png */}
      <div className='logoFullPage'>
        <div className='onLoading'>
          {/* <img src="/images/yumdel_logo.svg" width={180} height={37} alt="Logo" /> */}

          <img src="/images/Yop_Logo.png" width={180} height={37} alt="Logo" />

        </div>
      </div>
    </>
  )
}
